import styles from './styles.module.scss';

const LoadingIcon = () => {
    return (
        <img style={{width: '5rem'}} src='/favicon.png' alt='loading' className={styles.loading} />
    )
}

export default LoadingIcon;